import { ContentService } from '@blk/cwp-ng-framework';

import { NamedFormatter } from './named-formatter.interface';

export class ColorFormatter implements NamedFormatter {
	constructor(public readonly colorConstants?: any, public readonly defaultValue?: string) { }

	public attributeName(): string {
		return 'colorTheme';
	}

	public format(value: any, contentSvc?: ContentService): string {
		const dcrKey = value;
		let codeDefaultValue = value;
		if (this.colorConstants && this.colorConstants.hasOwnProperty(dcrKey)) {
			codeDefaultValue = this.colorConstants[dcrKey];
		}
		if (contentSvc) {
			return contentSvc.get(dcrKey, codeDefaultValue);
		}
		return codeDefaultValue;
	}
}
